/* BEGIN_COPYRIGHT_HEADER

Copyright Vspry International Limited (c) 2020
All rights reserved.

END_COPYRIGHT_HEADER */

import { plutoQuery, plutoMutation } from './gqlInterface'
import { mutationResponseString } from './types'

// queries
type GetUserBillCodeResponse = { billCode: string }
export const getUserBillCode = async () => plutoQuery<GetUserBillCodeResponse>`
    contact {
        billCode
    }
`

// mutations
type ReverseTransactionInput = {
    accountID: string
    holdingID: string
    amount: number
    transactionID: string
}
export const reverseTransaction = async (input: ReverseTransactionInput) => plutoMutation`
    reverseTransaction(input: ${input}) ${mutationResponseString}
`
type CreateMerchantBillInput = {
    accountID: string
    contact: string
    holding: string
    billCode: string
    amount: number
    description: string
}
export const createMerchantBill = async (input: CreateMerchantBillInput) => plutoMutation`
    createMerchantBill(input: ${input}) ${mutationResponseString}
`

type CreateConsumerBillInput = {
    accountID: string
    contactID: string
    merchantHoldingID: string
    amount: number
    description: string
}
export const createConsumerBill = async (input: CreateConsumerBillInput) => plutoMutation`
    createConsumerBill(input: ${input}) ${mutationResponseString}
`

type PayBillInput = {
    billID: string
    holdingID: string
}
export const payBill = async (input: PayBillInput) => plutoMutation`
    payBill(input: ${input}) ${mutationResponseString}
`

type CancelBillInput = {
    billID: string
}
export const cancelBill = async (input: CancelBillInput) => plutoMutation`
    cancelBill(input: ${input}) ${mutationResponseString}
`
